import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom } from 'rxjs';
import { authenticationProvider } from '../../../../../models/User';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private afFun: AngularFireFunctions
  ) { }

  async requestPasswordReset(email: string): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'FORGOT_PASSWORD',
        email: email
      })
    );
  }

  async checkAuthentication(email: string): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'CHECK_AUTHENTICATION',
        email: email
      })
    );
  }

  async confirmResetPassword(token: string): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'CONFIRM_RESET_PASSWORD',
        token: token
      })
    );
  }

  async resetPassword(token: string, newPassword: string): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'PASSWORD_RESET',
        token: token,
        newPassword: newPassword
      })
    );
  }

  async add(data: any, password: string | undefined, confirmPassword: string | undefined, lang: string = 'hu', provider: authenticationProvider): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'CREATE',
        userData: data,
        password: password,
        confirmPassword: confirmPassword,
        lang: lang,
        provider: provider
      })
    );
  }

  async delete(userId: string): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'DELETE',
        userId: userId,
      })
    );
  }

  async confirmEmailVerification(token: string): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'CONFIRM_EMAIL_VERIFICATION',
        token: token,
      })
    );
  }

  async update(data: any): Promise<any> {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'UPDATE',
        userData: data,
      })
    );
  }

  async joinGroup(studentId: string, studentEducationId: string, groupId: string, subjectId: string) {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'JOIN_GROUP',
        studentId: studentId,
        studentEducationId: studentEducationId,
        groupId: groupId,
        subjectId: subjectId
      })
    )
  }

  async leaveGroup(groupMembershipId: string, studentId: string, groupId: string) {
    return await firstValueFrom(
      this.afFun.httpsCallable('userFunctions')({
        action: 'LEAVE_GROUP',
        groupMembershipId: groupMembershipId,
        studentId: studentId,
        groupId: groupId
      })
    )
  }
}
